import { Injectable, inject } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { PrismDialogRef, PrismDialogService } from '@shure/prism-angular-components';
import { DialogData } from '@shure/shared/angular/ui/components/dialogs/common-models';

import { SingleDeviceAuthComponent, SingleDeviceAuthData, SingleDeviceAuthResult } from './components';

export const deviceAuthenticationPrompt = (device: SingleDeviceAuthData): Observable<SingleDeviceAuthResult> =>
	inject(DeviceAuthenticatePrompt).showDialog(device);

@Injectable({ providedIn: 'root' })
export class DeviceAuthenticatePrompt {
	public dialogRef: PrismDialogRef<SingleDeviceAuthComponent> | undefined;

	constructor(private readonly prismDialogService: PrismDialogService) {}
	public showDialog(promptData: SingleDeviceAuthData): Observable<SingleDeviceAuthResult> {
		if (!this.dialogRef) {
			this.dialogRef = this.prismDialogService.openDialog<
				SingleDeviceAuthComponent,
				SingleDeviceAuthData & DialogData,
				unknown
			>(SingleDeviceAuthComponent, {
				data: { ...promptData, blockElectronMenuAccess: true }
			});
		}

		return this.dialogRef.afterClosed$.pipe(
			tap(() => {
				this.dialogRef = undefined;
			})
		);
	}

	public closeDialog(): void {
		this.dialogRef?.close(SingleDeviceAuthResult.Cancelled);
		this.dialogRef = undefined;
	}
}
